<template lang="pug">
.page-top-area.fixed-top
.fixed.q-pt-sm
    base-full-spinner(
        v-if="loading"
        fixed
    )
        template(v-slot:spinner)
            q-spinner-dots(
                size="40px"
                color="positive"
            )
    header-mobile
        template(v-slot:leftIcon)
            q-icon.q-mr-sm.q-py-xs.q-pl-xs.q-pr-sm(
                name="etabl:arrow_prev"
                color="positive"
                size="xs"
                @click="router.go(-1)")
        template(v-slot:title)
            h1.font-14.text-positive.text-weight-bold.text-ellipsis.max-width-86(@click="router.go(-1)") {{ currentCategory.name }}



    .q-mt-sm
        q-expansion-item(
            v-if="currentCategory?.bread_crumbs[0].name == 'Оптика'"
            label="Запись на приём к врачу")
            .q-mx-md
                q-img(src="optika/banner-mobile.webp" alt="Баннер оптика" title="Оптика: Видите мир яснее с нашими услугами и продукцией").q-mt-xs.q-mb-xs.b-radius-16
                q-card.q-mt-md.q-mb-lg.b-radius-16.bg-secondary.q-pa-md.text-primary
                    .font-16.text-weight-bold.line-height-22
                        | Запись на консультацию к врачу-офтальмологу
                    .q-my-md.font-12.line-height-20(v-if="userAuthorized")
                        | Проверка зрения длится около 30 минут и включает в себя все 
                        | необходимые тесты. Выберите ближайший салон и удобное время!
                    .q-my-md.font-12.line-height-20(v-else)
                        | Чтобы записаться на прием к врачу-офтальмологу,  Вам необходимо пройти
                        | процесс авторизации или регистрации.
                    base-btn(
                        :label="userAuthorized ? 'Выберите адрес салона' : 'Войти'"
                        height="40"
                        bradius="16"
                        @click="userAuthorized ? goToAppointment('/optika-article?map=open') : showAuth()"
                    )
        q-expansion-item(
            v-if="currentCategory?.bread_crumbs[0].name == 'Ортопедия'"
            label="Запись на изготовление стелек")
            .q-mx-md
                q-img(src="orthopedics/banner-mobile.webp" alt="Баннер ортопедия" title="Ортопедия: Заботьтесь о своем здоровье с нашими инновационными решениями").q-mb-lg.b-radius-16
                q-card.q-mt-md.q-mb-lg.b-radius-16.bg-secondary.q-pa-md.text-primary
                    .font-16.text-weight-bold.line-height-22
                        | Запись на индивидуальное изготовление стелек
                    .q-my-md.font-12.line-height-20(v-if="userAuthorized")
                        | Процесс изготовления длится не менее 40 минут и включает в себя все
                        | необходимые процедуры. Выберите ближайший салон и удобное время!
                    .q-my-md.font-12.line-height-20(v-else)
                        | Чтобы записаться на индивидуальное изготовление стелек,  Вам необходимо
                        | пройти процесс авторизации или регистрации.
                    base-btn(
                        :label="userAuthorized ? 'Выберите адрес салона' : 'Войти'"
                        height="40"
                        bradius="16"
                        @click="userAuthorized ? goToAppointment('/orthopedics-article?map=open') : showAuth()"
                    )
        .row.full-width.justify-between.q-px-md.q-py-sm
            q-icon.q-ml-xs(
                size="20px"
                color="positive"
                :name="isVertical ? 'etabl:list' : 'etabl:blocks'"
                @click="changeViewPreview")
            sorting-mobile
            filters-mobile(
                v-if="filters"
                :propFilters="filters"
                :currentCategory="currentCategory?.slug_name")
div(:style="currentCategory.seo_content ? '' : 'margin-bottom: 70px'")
    .row.iris-banner-wrap.q-px-md
        div.mobile-full.q-my-md.q-pt-sm#adfox_173504687401219080
    product-list-mobile(
        :propLoading="loading"
        :propProducts="products"
        :isVertical="isVertical"
        :customOffset="customOffset")
.q-mt-lg.q-mx-md#ceo(v-html="currentCategory.seo_content" v-if="currentCategory.seo_content" style="margin-bottom: 70px")
base-button-top-mobile

</template>

<script>
import { scroll } from 'quasar';
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import HeaderMobile from 'components/Header/HeaderMobile.vue';
import SortingMobile from 'components/Sorting/SortingMobile.vue';
import FiltersMobile from 'components/Filters/FiltersMobile.vue';
import BaseButtonTopMobile from 'components/Base/BaseButtonTopMobile.vue';
import ProductListMobile from 'components/ProductList/ProductListMobile.vue';
import BaseBtn from 'src/components/Base/BaseBtn.vue';
import BaseFullSpinner from 'components/Base/BaseFullSpinner.vue';

const { getScrollTarget, setVerticalScrollPosition } = scroll;


export default {
    name: 'CatalogMobile',
    components: {
        BaseFullSpinner,
        HeaderMobile,
        SortingMobile,
        FiltersMobile,
        ProductListMobile,
        BaseButtonTopMobile,
        BaseBtn,
    },
    setup() {
        const route = useRoute();
        const router = useRouter();

        const store = useStore();
        const isVertical = ref(false);
        const ceo = ref(null);
        const customOffset = ref(150);

        // фильтры каталога
        const filters = computed(() => store.getters['catalog/CATALOG_FILTERS']);

        // продукты
        const products = computed(() => store.getters['catalog/PRODUCTS']);

        // состояние загрузки
        const loading = computed(() => store.getters['catalog/LOADING']);

        // категории id:url
        const categoriesIdToUrl = computed(() => store.getters['categories/CATEGORIES_ID_TO_URL']);

        // категории url:id
        const categoriesUrlToId = computed(() => store.getters['categories/CATEGORIES_URL_TO_ID']);

        // текущая категория
        const currentCategory = computed(() => store.getters['categories/CURRENT_NCATEGORY']);

        // авторизован ли пользователь
        const userAuthorized = computed(() => store.getters['user/USER_AUTHORIZED']);

        // город пользователя
        const city = computed(() => store.getters['cityForm/CITY']);

        const parentId = computed(() => categoriesIdToUrl.value[currentCategory.value.parent_section_id]);

        const headerHeight = computed(() => {
            return process.env.CLIENT
                ? document.querySelector('.header')?.offsetHeight
                : 0;
        });

        const categoryCeo = computed(() => store.getters['categories/CATEGORIES_META']);


        const setCustomOffset = () => {
            ceo.value = document.getElementById('ceo');
            customOffset.value = ceo.value.getBoundingClientRect().height + 400;
        };

        const goToAppointment = (val) => {
            router.push(city.value ? `/${city.value.slug}${val}` : val);
        };

        const changeViewPreview = async () => {
            store.commit('catalog/SET_LOADING', true);
            isVertical.value = !isVertical.value;
            setTimeout(() => {
                store.commit('catalog/SET_LOADING', false);

            }, 100);
        };

        onMounted(async () => {
            if (categoryCeo.value) {
                setCustomOffset();
            }
            if (process.env.CLIENT) {
                window.yaContextCb.push(() => {
                    Ya.adfoxCode.create({
                        ownerId: 5202103,
                        containerId: 'adfox_173504687401219080',
                        params: {
                            p1: 'dfnva',
                            p2: 'ixfw',
                        },
                    });
                });
                setTimeout(() => {
                    document.querySelectorAll('.iris-banner-wrap').forEach((elem) => {
                        if (elem.firstChild && elem.firstElementChild.firstChild) {
                            elem.firstElementChild.classList.add('not-empty');
                        }
                    });
                }, 1500);
            }
        });

        return {
            ceo,
            route,
            filters,
            loading,
            products,
            parentId,
            isVertical,
            currentCategory,
            router: useRouter(),
            categoryCeo,
            customOffset,
            userAuthorized,
            city,
            goToAppointment,
            changeViewPreview,
        };
    },
};
</script>

<style lang="scss" scoped>
.fixed {
    background-color: #fbfafa;
    position: sticky;
    z-index: 2;
    top: 0;
}
</style>
